import { SET_FOCUSED } from "./types";
export var setFocused = function setFocused(focused) {
  return {
    type: SET_FOCUSED,
    focused: focused
  };
};